import { render, staticRenderFns } from "./splitPaymentDialog.vue?vue&type=template&id=67dff9d4&"
import script from "./splitPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./splitPaymentDialog.vue?vue&type=script&lang=js&"
import style0 from "./splitPaymentDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports